<div id="st-point-leaderboard-point-leaderboard-container" class="point-leaderboard-container" [class.t1-page]="isTemplate1" (click)="onContainerClick($event)" (keydown.enter)="onContainerClick($any($event))" (keydown.space)="$event.preventDefault(); onContainerClick($any($event))">
  <div id="st-point-leaderboard-header-leaderboard" class="header-leaderboard">
    <span class="header-title" *ngIf="!isMobileView || !mobileSearchExpanded">{{ "ranking_leaderboard" | translate
      }}</span>
    <div id="st-point-leaderboard-search-and-buttons" class="search-and-buttons">
      <div id="st-point-leaderboard-search-bar" class="search-bar" [class.mobile-expanded]="mobileSearchExpanded">
        <button type="button" (click)="toggleMobileSearch()" (keydown.enter)="toggleMobileSearch()" (keydown.space)="$event.preventDefault(); toggleMobileSearch()"><img src="../../../assets/ranking-rating_assets/search.svg" alt="Search" class="search-icon" /></button>
        <input type="text" class="search-input" placeholder="{{ 'search_player' | translate }}" [(ngModel)]="searchTerm"
          (input)="onSearch()" />
      </div>
      <div id="st-point-leaderboard-button-group" class="button-group">
        <div id="st-point-leaderboard-filters-btn" class="filters-btn d-flex align-items-center justify-content-center gap-2" [class.filters-active]="areFiltersApplied">
          <button type="button" class="btn p-0 border-0 bg-transparent d-flex align-items-center justify-content-center gap-2 text-reset shadow-none" (click)="toggleSidebar()" (keydown.enter)="toggleSidebar()" (keydown.space)="$event.preventDefault(); toggleSidebar()" tabindex="0">
            <img src="../../../assets/ranking-rating_assets/page_info.svg" alt="Filters" class="filter-icon" />

            <span class="filter-text">{{ "filter" | translate }}</span>
          </button>
          @if (areFiltersApplied) {
            <button type="button" class="remove-filters btn p-0 border-0 bg-transparent d-none d-xl-flex align-items-center ms-1 shadow-none" (click)="$event.stopPropagation(); removeFilters()" (keydown.enter)="$any($event).stopPropagation(); removeFilters()" (keydown.space)="$event.preventDefault(); $any($event).stopPropagation(); removeFilters()" tabindex="0">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0.965937 12.1985L0 11.2326L5.13333 6.09927L0 0.965938L0.965937 0L6.09927 5.13333L11.2326 0L12.1985 0.965938L7.06521 6.09927L12.1985 11.2326L11.2326 12.1985L6.09927 7.06521L0.965937 12.1985Z"
                fill="var(--primary-color)" />
            </svg>

            </button>
          }
        </div>
        <div id="st-point-leaderboard-filters-btn-1" *ngIf="rankingListLastUpdatedAt" class="filters-btn last-updated-btn">
          
          <span class="filter-text">{{ "last_updated" | translate }} </span>
          <span class="date-text">{{
            rankingListLastUpdatedAt | date: "dd MMMM yyyy"
            }}</span>
        </div>
      </div>
    </div>
  </div>
  <div id="st-point-leaderboard-category-filter" class="category-filter">
    <!-- Desktop: Level dropdown + Category scroll list -->
    <div id="st-point-leaderboard-category-filter-desktop" class="category-filter-desktop">
      <div id="st-point-leaderboard-level" class="level" (click)="toggleDropdown($event)" (keydown.enter)="toggleDropdown($any($event))" (keydown.space)="$event.preventDefault(); toggleDropdown($any($event))">
        <div id="st-point-leaderboard-level-wrapper" class="level-wrapper">
          <span class="level-name">{{ selectedLevel }}</span>
          <img src="../../../assets/ranking-rating_assets/dropdown_arrow_leaderboard.svg" alt="Dropdown Arrow"
            class="dropdown-arrow" />
        </div>
        <div id="st-point-leaderboard-dropdown-menu" class="dropdown-menu" *ngIf="isDropdownOpen">
          <button type="button" (click)="selectLevel(level.level); $event.stopPropagation()" (keydown.enter)="selectLevel(level.level); $any($event).stopPropagation()" (keydown.space)="$event.preventDefault(); selectLevel(level.level); $any($event).stopPropagation()" *ngFor="let level of levels; trackBy: trackById" [id]="'st-point-leaderboard-dropdown-item' + (level)" class="dropdown-item">
            {{ level.level }}
          </button>
        </div>
      </div>
      <div id="st-point-leaderboard-category" class="category">
        <button class="scroll-btn left" (click)="scrollCategories('left')" (keydown.enter)="scrollCategories('left')" (keydown.space)="$event.preventDefault(); scrollCategories('left')" tabindex="0">
          <svg width="4" height="8" viewBox="0 0 4 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 0L4 8L3.49691e-07 4L4 0Z" fill="var(--stupa_primary_text_color)" />
          </svg>
        </button>
        <div id="st-point-leaderboard-category-list" #categoryList class="category-list">
          <button type="button" (click)="selectCategory(category.category_description)" (keydown.enter)="selectCategory(category.category_description)" (keydown.space)="$event.preventDefault(); selectCategory(category.category_description)" *ngFor="let category of categories; trackBy: trackById" [id]="'st-point-leaderboard-category-item' + (category)" class="category-item" [class.selected]="category.category_description === selectedCategory">
            {{ category.category_description }}
          </button>
        </div>
        <button class="scroll-btn right" (click)="scrollCategories('right')" (keydown.enter)="scrollCategories('right')" (keydown.space)="$event.preventDefault(); scrollCategories('right')" tabindex="0">
          <svg class="right-arrow" width="4" height="8" viewBox="0 0 4 8" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M4 0L4 8L3.49691e-07 4L4 0Z" fill="var(--stupa_primary_text_color)" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Mobile: Shared selector design (same as events results) -->
    <div id="st-point-leaderboard-category-filter-mobile" class="category-filter-mobile">
      <stupa-mobile-participant-category-selector class="w-100" [participant_list]="mobileParticipantOptions"
        [category_list]="category_list" [active_participant_id]="activeLevelId"
        [active_category_id]="selectedCategoryId" (participantChange)="onMobileLevelChange($event)"
        (category_selection)="onMobileCategoryChange($event)"></stupa-mobile-participant-category-selector>
      
    </div>
    <!-- Mobile expanded search -->
    
  </div>

  <!-- Desktop Podium (visible on xl+) -->
  <div id="st-point-leaderboard-leaderboard-container" class="leaderboard-container d-none d-xl-block" *ngIf="showPodium() && !isCategoryOnHold">
    <div id="st-point-leaderboard-sch-main-container-expanded" class="gap-2 sch-main-container-expanded d-flex align-items-center w-100" [ngStyle]="podiumBackgroundNgStyle">
      <div id="st-point-leaderboard-podium-container" class="podium-container w-100">
        <!-- Second Place -->
        <div id="st-point-leaderboard-podium-cube" class="podium-cube second-place">
          <div id="st-point-leaderboard-cube-content" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-second" class="player-image-wrapper-second">
              <img [src]="
                  podiumRank2?.player_profile ||
                  setAvatarByGender(podiumRank2?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name-second-third" class="participant-name-second-third">
                {{ podiumRank2?.player }}
              </div>
              
            </div>
            <svg width="100%" height="100%" viewBox="0 0 303 103" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66.5 1L372.5 1.5L357 25V58L2 59L66.5 1Z" fill="#4D75AD" stroke="white" />
              <path d="M2 138V58.9877L357 57.9999V138H2Z" fill="url(#paint0_linear_9652_81372_second)" stroke="white" />
              <defs>
                <linearGradient id="paint0_linear_9652_81372_second" x1="183" y1="29.1887" x2="183" y2="137.831"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#4D75AD" />
                  <stop offset="1" stop-color="#203047" />
                </linearGradient>
              </defs>
            </svg>
            <div id="st-point-leaderboard-badge-container-second" class="badge-container-second">
              <div id="st-point-leaderboard-block" class="d-flex align-items-center">
                <div id="st-point-leaderboard-block-2" class="medal">
                  <img src="../../../assets/BrandImages/second-medal.png" alt="Second Place Medal" />
                </div>
                <div id="st-point-leaderboard-rank2" class="rank2">2<sup>nd</sup></div>
                <div id="st-point-leaderboard-points-info-side-second" class="points-info-side-second">
                  <span class="points-label-second">{{ "points_earned" | translate }}:</span>
                  <span class="points-value-second">{{
                    podiumRank2?.points
                    }}</span>
                </div>
                <img *ngIf="podiumRank2?.movementIndicator === '+'"
                  src="../../../assets/ranking-rating_assets/positive_indicator.svg" alt="Rank Up"
                  class="podium-rank-indicator-second" />
                <img *ngIf="podiumRank2?.movementIndicator === '-'"
                  src="../../../assets/ranking-rating_assets/negative_indicator.svg" alt="Rank Down"
                  class="podium-rank-indicator-second" />
                
                <!-- hide image as BE provision is missing -->
              </div>
            </div>
          </div>
        </div>

        <!-- First Place -->
        <div id="st-point-leaderboard-podium-cube-3" class="podium-cube first-place">
          <div id="st-point-leaderboard-cube-content-4" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-first" class="player-image-wrapper-first">
              <img [src]="
                  podiumRank1?.player_profile ||
                  setAvatarByGender(podiumRank1?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details-5" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name" class="participant-name">
                {{ podiumRank1?.player }}
              </div>
              
            </div>
            <svg width="100%" height="100%" viewBox="0 0 438 220" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g filter="url(#filter0_d_9652_81426)">
                <path d="M17 106L76.8522 16H360.651L421 106H17Z" fill="url(#paint0_linear_9652_81426)" />
                <path d="M17 106L76.8522 16H360.651L421 106H17Z" stroke="white" />
              </g>
              <g filter="url(#filter1_d_9652_81426)">
                <path d="M17 219V106H421V219H17Z" fill="url(#paint1_linear_9652_81426)" />
                <path d="M17 219V106H421V219H17Z" stroke="white" />
              </g>
              <defs>
                <filter id="filter0_d_9652_81426" x="0.966894" y="0.4" width="436.071" height="121.2"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="7.55" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix"
                    values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9652_81426" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9652_81426" result="shape" />
                </filter>
                <filter id="filter1_d_9652_81426" x="1.4" y="90.4" width="435.2" height="144.2"
                  filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha" />
                  <feOffset />
                  <feGaussianBlur stdDeviation="7.55" />
                  <feComposite in2="hardAlpha" operator="out" />
                  <feColorMatrix type="matrix"
                    values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_9652_81426" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_9652_81426" result="shape" />
                </filter>
                <linearGradient id="paint0_linear_9652_81426" x1="246" y1="105.829" x2="248.5" y2="15.8286"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#4EA8F3" />
                  <stop offset="1" stop-color="#4D98D7" />
                </linearGradient>
                <linearGradient id="paint1_linear_9652_81426" x1="219" y1="54.8286" x2="219" y2="219"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#62CFF4" />
                  <stop offset="1" stop-color="#2C67F2" />
                </linearGradient>
              </defs>
            </svg>
            <div id="st-point-leaderboard-badge-container-first" class="badge-container-first">
              <div id="st-point-leaderboard-block-6" class="gap-2 d-flex align-items-center">
                <div id="st-point-leaderboard-block-7" class="medal">
                  <img src="../../../assets/BrandImages/first_medal.png" alt="First Place Medal" />
                </div>
                <div id="st-point-leaderboard-rank" class="rank">1<sup>st</sup></div>
              </div>
              <div id="st-point-leaderboard-block-8" class="d-flex align-items-center">
                <div id="st-point-leaderboard-points-info-below-rank" class="points-info-below-rank">
                  <span class="points-label">{{ 'points_earned' | translate }}:</span>
                  <span class="points-value">{{
                    podiumRank1?.points
                    }}</span>
                </div>
                <img *ngIf="podiumRank1?.movementIndicator === '+'"
                  src="../../../assets/ranking-rating_assets/positive_indicator.svg" alt="Rank Up"
                  class="podium-rank-indicator" />
                <img *ngIf="podiumRank1?.movementIndicator === '-'"
                  src="../../../assets/ranking-rating_assets/negative_indicator.svg" alt="Rank Down"
                  class="podium-rank-indicator" />
                
                <!-- hide image as BE provision is missing -->
              </div>
            </div>
          </div>
        </div>

        <!-- Third Place -->
        <div id="st-point-leaderboard-podium-cube-9" class="podium-cube third-place">
          <div id="st-point-leaderboard-cube-content-10" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-third" class="player-image-wrapper-third">
              <img [src]="
                  podiumRank3?.player_profile ||
                  setAvatarByGender(podiumRank3?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details-11" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name-second-third-12" class="participant-name-second-third">
                {{ podiumRank3?.player }}
              </div>
              
            </div>
            <svg width="100%" height="100%" viewBox="0 0 303 103" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M229.762 1.5L1 0.5V56H301L229.762 1.5Z" fill="#092878" stroke="white" />
              <path d="M301 102V56H1V102H301Z" fill="url(#paint0_linear_9652_81375)" stroke="white" />
              <defs>
                <linearGradient id="paint0_linear_9652_81375" x1="156.779" y1="56.3226" x2="156.779" y2="130.438"
                  gradientUnits="userSpaceOnUse">
                  <stop stop-color="#2045A5" />
                  <stop offset="1" stop-color="#010E2F" />
                </linearGradient>
              </defs>
            </svg>
            <div id="st-point-leaderboard-badge-container-third" class="badge-container-third">
              <div id="st-point-leaderboard-block-13" class="d-flex align-items-center">
                <div id="st-point-leaderboard-block-14" class="medal">
                  <img src="../../../assets/BrandImages/third_medal.png" alt="Third Place Medal" />
                </div>
                <div id="st-point-leaderboard-rank3" class="rank3">3<sup>rd</sup></div>
                <div id="st-point-leaderboard-points-info-side-third" class="points-info-side-third">
                  <span class="points-label-third">{{ "points_earned" | translate }}:</span>
                  <span class="points-value-third">{{
                    podiumRank3?.points
                    }}</span>
                </div>
                <img *ngIf="podiumRank3?.movementIndicator === '+'"
                  src="../../../assets/ranking-rating_assets/positive_indicator.svg" alt="Rank Up"
                  class="podium-rank-indicator-third" />
                <img *ngIf="podiumRank3?.movementIndicator === '-'"
                  src="../../../assets/ranking-rating_assets/negative_indicator.svg" alt="Rank Down"
                  class="podium-rank-indicator-third" />
                <img *ngIf="
                    podiumRank3?.movementIndicator !== '+' &&
                    podiumRank3?.movementIndicator !== '-'
                  " src="../../../assets/ranking-rating_assets/nochange_indicator.svg" alt="No Change"
                  class="podium-rank-indicator-third" />
                
                <!-- hide image as BE provision is missing -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- mobile view podium starts here -->
  <div id="st-point-leaderboard-leaderboard-container-15" class="leaderboard-container mobile-podium-view d-block d-xl-none" *ngIf="showPodium() && !isCategoryOnHold">
    <div id="st-point-leaderboard-sch-main-container-expanded-16" class="sch-main-container-expanded mobile-podium-shell d-flex w-100" [ngStyle]="podiumBackgroundNgStyle">
      <div id="st-point-leaderboard-mobile-podium-stage" class="mobile-podium-stage">
        <!-- Second Place -->
        <div id="st-point-leaderboard-podium-cube-17" class="podium-cube second-place">
          <div id="st-point-leaderboard-cube-content-18" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-second-19" class="player-image-wrapper-second">
              <img [src]="
                  podiumRank2?.player_profile ||
                  setAvatarByGender(podiumRank2?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details-20" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name-second-third-21" class="participant-name-second-third">
                {{ podiumRank2?.player }}
              </div>
            </div>
            <div id="st-point-leaderboard-mob-svg-wrapper" class="mob-svg-wrapper mob-svg-second">
              <svg width="100%" height="100%" viewBox="0 0 303 138" preserveAspectRatio="none" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M66.5 1L372.5 1.5L357 25V58L2 59L66.5 1Z" fill="#4D75AD" stroke="white" />
                <path d="M2 138V58.9877L357 57.9999V138H2Z" fill="url(#mob_paint_second)" stroke="white" />
                <defs>
                  <linearGradient id="mob_paint_second" x1="183" y1="29.1887" x2="183" y2="137.831"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#4D75AD" />
                    <stop offset="1" stop-color="#203047" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div id="st-point-leaderboard-badge-container-second-22" class="badge-container-second">
              <div id="st-point-leaderboard-mob-badge-row" class="mob-badge-row">
                <div id="st-point-leaderboard-mob-medal-rank-row" class="mob-medal-rank-row">
                  <div id="st-point-leaderboard-block-23" class="medal">
                    <img src="../../../assets/BrandImages/second-medal.png" alt="Second Place Medal" />
                  </div>
                  <div id="st-point-leaderboard-rank2-24" class="rank2">2<sup>nd</sup></div>
                </div>
                <div id="st-point-leaderboard-mob-points-pill" class="mob-points-pill">
                  <span class="points-label-second">{{ "points_earned" | translate }}:</span>
                  <span class="points-value-second">{{ podiumRank2?.points }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- First Place -->
        <div id="st-point-leaderboard-podium-cube-25" class="podium-cube first-place">
          <div id="st-point-leaderboard-cube-content-26" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-first-27" class="player-image-wrapper-first">
              <img [src]="
                  podiumRank1?.player_profile ||
                  setAvatarByGender(podiumRank1?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details-28" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name-29" class="participant-name">
                {{ podiumRank1?.player }}
              </div>
            </div>
            <div id="st-point-leaderboard-mob-svg-wrapper-30" class="mob-svg-wrapper mob-svg-first">
              <svg width="100%" height="100%" viewBox="0 0 438 220" preserveAspectRatio="none" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#mob_filter0_first)">
                  <path d="M17 106L76.8522 16H360.651L421 106H17Z" fill="url(#mob_paint0_first)" />
                  <path d="M17 106L76.8522 16H360.651L421 106H17Z" stroke="white" />
                </g>
                <g filter="url(#mob_filter1_first)">
                  <path d="M17 219V106H421V219H17Z" fill="url(#mob_paint1_first)" />
                  <path d="M17 219V106H421V219H17Z" stroke="white" />
                </g>
                <defs>
                  <filter id="mob_filter0_first" x="0.966894" y="0.4" width="436.071" height="121.2"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="7.55" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix"
                      values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                  </filter>
                  <filter id="mob_filter1_first" x="1.4" y="90.4" width="435.2" height="144.2"
                    filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="7.55" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix"
                      values="0 0 0 0 0.231373 0 0 0 0 0.509804 0 0 0 0 0.964706 0 0 0 0.2 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                  </filter>
                  <linearGradient id="mob_paint0_first" x1="246" y1="105.829" x2="248.5" y2="15.8286"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#4EA8F3" />
                    <stop offset="1" stop-color="#4D98D7" />
                  </linearGradient>
                  <linearGradient id="mob_paint1_first" x1="219" y1="54.8286" x2="219" y2="219"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#62CFF4" />
                    <stop offset="1" stop-color="#2C67F2" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div id="st-point-leaderboard-badge-container-first-31" class="badge-container-first">
              <div id="st-point-leaderboard-mob-medal-rank-row-32" class="mob-medal-rank-row">
                <div id="st-point-leaderboard-block-33" class="medal">
                  <img src="../../../assets/BrandImages/first_medal.png" alt="First Place Medal" />
                </div>
                <div id="st-point-leaderboard-rank-34" class="rank">1<sup>st</sup></div>
              </div>
              <div id="st-point-leaderboard-mob-points-pill-35" class="mob-points-pill">
                <span class="points-label">{{ 'points_earned' | translate }}:</span>
                <span class="points-value">{{ podiumRank1?.points }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Third Place -->
        <div id="st-point-leaderboard-podium-cube-36" class="podium-cube third-place">
          <div id="st-point-leaderboard-cube-content-37" class="cube-content">
            <div id="st-point-leaderboard-player-image-wrapper-third-38" class="player-image-wrapper-third">
              <img [src]="
                  podiumRank3?.player_profile ||
                  setAvatarByGender(podiumRank3?.gender_id || '')
                " alt="Player Profile" class="player-profile-pic-podium" />
            </div>
            <div id="st-point-leaderboard-podium-player-details-39" class="podium-player-details">
              <div id="st-point-leaderboard-participant-name-second-third-40" class="participant-name-second-third">
                {{ podiumRank3?.player }}
              </div>
            </div>
            <div id="st-point-leaderboard-mob-svg-wrapper-41" class="mob-svg-wrapper mob-svg-third">
              <svg width="100%" height="100%" viewBox="0 0 303 102" preserveAspectRatio="none" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M229.762 1.5L1 0.5V56H301L229.762 1.5Z" fill="#092878" stroke="white" />
                <path d="M301 102V56H1V102H301Z" fill="url(#mob_paint_third)" stroke="white" />
                <defs>
                  <linearGradient id="mob_paint_third" x1="156.779" y1="56.3226" x2="156.779" y2="130.438"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#2045A5" />
                    <stop offset="1" stop-color="#010E2F" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div id="st-point-leaderboard-badge-container-third-42" class="badge-container-third">
              <div id="st-point-leaderboard-mob-badge-row-43" class="mob-badge-row mob-badge-row-third">
                <div id="st-point-leaderboard-mob-medal-rank-row-44" class="mob-medal-rank-row">
                  <div id="st-point-leaderboard-block-45" class="medal">
                    <img src="../../../assets/BrandImages/third_medal.png" alt="Third Place Medal" />
                  </div>
                  <div id="st-point-leaderboard-rank3-46" class="rank3">3<sup>rd</sup></div>
                </div>
                <div id="st-point-leaderboard-mob-points-pill-47" class="mob-points-pill mob-points-pill-third">

                  <span class="points-value-third">{{
                    (podiumRank3?.points || 0)
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- mobile view podium ends here -->


  <div id="st-point-leaderboard-ranking-table-container" *ngIf="rankings.length != 0 && !_showLoader && !isCategoryOnHold" class="ranking-table-container">
    <ng-container *ngIf="layoutWide1024">
      <div id="st-point-leaderboard-ranking-grid" class="ranking-grid" [ngClass]="{'ello-table': leaderboardMode === 'RankingAndRating'}"
        [style.gridTemplateColumns]="gridTemplateColumns">
        <button type="button" (click)="toggleSort('rank')" (keydown.enter)="toggleSort('rank')" (keydown.space)="$event.preventDefault(); toggleSort('rank')" id="st-point-leaderboard-grid-header" class="grid-header rank">
          {{ "rank" | translate | uppercase }}
          <img *ngIf="leaderboardMode === 'RankingAndRating'" src="../../../assets/ranking-rating_assets/sort_icon.svg"
            alt="Sort Rank" class="sort-icon combined-sort-icon" [ngClass]="{
            'active': isCombinedSortActive('rank'),
            'desc': isCombinedSortDesc('rank')
          }" />
        </button>
        <button type="button" (click)="toggleSort('player')" (keydown.enter)="toggleSort('player')" (keydown.space)="$event.preventDefault(); toggleSort('player')" id="st-point-leaderboard-grid-header-48" class="grid-header player">
          {{ "player" | translate | uppercase }}
        </button>
        <ng-container *ngIf="parent_role_list.length > 0">
          
          <div [id]="'st-point-leaderboard-grid-header-50' + (role)" *ngFor="let role of parent_role_list; trackBy: trackById" class="grid-header club-ma">
            {{ role.parent_role_name | uppercase }}
            
          </div>
        </ng-container>
        <ng-container *ngIf="parent_role_list.length === 0">
          <button type="button" (click)="toggleSort('club/ma')" (keydown.enter)="toggleSort('club/ma')" (keydown.space)="$event.preventDefault(); toggleSort('club/ma')" id="st-point-leaderboard-grid-header-51" class="grid-header club-ma">
            {{ 'club' | translate | uppercase }}
            <img src="../../../assets/ranking-rating_assets/sort_icon.svg" alt="Sort Club/MA" class="sort-icon" />
          </button>
        </ng-container>
        <ng-container *ngIf="leaderboardMode === 'RankingAndRating'; else rankingHeaders">
          <button type="button" (click)="toggleSort('ranking_points')" (keydown.enter)="toggleSort('ranking_points')" (keydown.space)="$event.preventDefault(); toggleSort('ranking_points')" id="st-point-leaderboard-grid-header-52" class="grid-header points">
            {{ "bonus points" | uppercase }}
            <img src="../../../assets/ranking-rating_assets/sort_icon.svg" alt="Sort Bonus Points"
              class="sort-icon combined-sort-icon" [ngClass]="{
              'active': isCombinedSortActive('ranking_points'),
              'desc': isCombinedSortDesc('ranking_points')
            }" />
          </button>
          <button type="button" (click)="toggleSort('rating_points')" (keydown.enter)="toggleSort('rating_points')" (keydown.space)="$event.preventDefault(); toggleSort('rating_points')" id="st-point-leaderboard-grid-header-53" class="grid-header points">
            {{ "elo points" | uppercase }}
            <img src="../../../assets/ranking-rating_assets/sort_icon.svg" alt="Sort Elo Points"
              class="sort-icon combined-sort-icon" [ngClass]="{
              'active': isCombinedSortActive('rating_points'),
              'desc': isCombinedSortDesc('rating_points')
            }" />
          </button>
          <button type="button" (click)="toggleSort('total_points')" (keydown.enter)="toggleSort('total_points')" (keydown.space)="$event.preventDefault(); toggleSort('total_points')" id="st-point-leaderboard-grid-header-54" class="grid-header points">
            {{ "total points" | uppercase }}
            <img src="../../../assets/ranking-rating_assets/sort_icon.svg" alt="Sort Total Points"
              class="sort-icon combined-sort-icon" [ngClass]="{
              'active': isCombinedSortActive('total_points'),
              'desc': isCombinedSortDesc('total_points')
            }" />
          </button>
          <div id="st-point-leaderboard-grid-header-55" class="grid-header breakdown"></div>
        </ng-container>
        <ng-template #rankingHeaders>
          <div id="st-point-leaderboard-grid-header-56" class="grid-header points">
            {{ "points" | translate | uppercase }}
            
          </div>

          <!-- NEW: Dynamic Event Headers -->
          <div [id]="'st-point-leaderboard-grid-header-57' + (event)" *ngFor="let event of filteredEventNamesForView; trackBy: trackById"
            class="grid-header event-points">
            {{ event.event_name | uppercase }}
          </div>
          <div id="st-point-leaderboard-grid-header-58" class="grid-header breakdown"></div>
        </ng-template>
      </div>

      <!-- MODIFIED: Bind grid-template-columns and add dynamic data cells -->
      @for (ranking of rankings; track trackRanking($index, ranking)) {
      <div id="st-point-leaderboard-ranking-row" class="ranking-row" [style.gridTemplateColumns]="gridTemplateColumns">
        <div id="st-point-leaderboard-grid-cell" class="grid-cell rank">
          <ng-container *ngIf="leaderboardMode !== 'RankingAndRating'">
            <img *ngIf="ranking.movementIndicator === '+'"
              src="../../../assets/ranking-rating_assets/positive_indicator.svg" alt="Rank Up" class="rank-indicator" />
            <img *ngIf="ranking.movementIndicator === '-'"
              src="../../../assets/ranking-rating_assets/negative_indicator.svg" alt="Rank Down"
              class="rank-indicator" />
          </ng-container>
          
          <!-- hide image as BE provision is missing -->
          <span class="rank-number">{{ ranking.rank }}</span>
        </div>
        <div id="st-point-leaderboard-grid-cell-59" class="grid-cell player">
          <img [src]="
            ranking?.player_profile ||
            setAvatarByGender(ranking?.gender_id || '')
          " alt="Player Profile" class="player-profile-pic" />
          <span class="player-name st-ellipsis" tooltipPosition="right" [pTooltip]="ranking?.player || ''"
            tooltipStyleClass="stupa-compact-tooltip">
            {{ ranking?.player }}
          </span>
          <img *ngIf="leaderboardMode !== 'RankingAndRating' && ranking.is_paused"
            src="../../../assets/ranking-rating_assets/pause_player.svg" alt="Paused Player" class="pause-icon" />
        </div>
        <!-- Dynamic parent role cells -->
        <ng-container *ngIf="parent_role_list.length > 0">
          <div [id]="'st-point-leaderboard-grid-cell-60' + role" *ngFor="let role of parent_role_list; trackBy: trackById" class="grid-cell club-ma">
            <span class="st-ellipsis w-100" tooltipPosition="left"
              [pTooltip]="getParentValueForRole(ranking, role.parent_role_id)"
              tooltipStyleClass="stupa-compact-tooltip">
              {{ getParentValueForRole(ranking, role.parent_role_id) }}
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="parent_role_list.length === 0">
          <div id="st-point-leaderboard-grid-cell-61" class="grid-cell club-ma">
            <span class="st-ellipsis w-100" tooltipPosition="left" [pTooltip]="ranking?.clubMa || ''"
              tooltipStyleClass="stupa-compact-tooltip">
              {{ ranking?.clubMa }}
            </span>
          </div>
        </ng-container>
        <ng-container *ngIf="leaderboardMode === 'RankingAndRating'; else rankingCells">
          <div id="st-point-leaderboard-grid-cell-62" class="grid-cell points">{{ ranking?.bonusPoints ?? 0 }}</div>
          <div id="st-point-leaderboard-grid-cell-63" class="grid-cell points">{{ ranking?.eloPoints ?? 0 }}</div>
          <div id="st-point-leaderboard-grid-cell-64" class="grid-cell points">{{ ranking?.totalPoints ?? 0 }}</div>
          <div id="st-point-leaderboard-grid-cell-65" class="grid-cell breakdown">
            <button type="button" (click)="onBreakdownClick(ranking, $event)" (keydown.enter)="onBreakdownClick(ranking, $any($event))" (keydown.space)="$event.preventDefault(); onBreakdownClick(ranking, $any($event))"><img src="../../../assets/ranking-rating_assets/point_breakdown.svg" alt="Breakdown Details" class="breakdown-btn" /></button>
          </div>
        </ng-container>
        <ng-template #rankingCells>
          <div id="st-point-leaderboard-grid-cell-66" class="grid-cell points">{{ ranking?.points }}</div>
          <div [id]="'st-point-leaderboard-grid-cell-67' + (event)" *ngFor="let event of filteredEventNamesForView; trackBy: trackById"
            class="grid-cell event-points">
            <span class="st-ellipsis w-100" tooltipPosition="left"
              [pTooltip]="(ranking.event_points?.[event.event_id] ?? '-') + ''"
              tooltipStyleClass="stupa-compact-tooltip">
              {{ ranking.event_points?.[event.event_id] || "-" }}
            </span>
          </div>
          <div id="st-point-leaderboard-grid-cell-68" class="grid-cell breakdown">
            <button type="button" (click)="onBreakdownClick(ranking, $event)" (keydown.enter)="onBreakdownClick(ranking, $any($event))" (keydown.space)="$event.preventDefault(); onBreakdownClick(ranking, $any($event))"><img src="../../../assets/ranking-rating_assets/point_breakdown.svg" alt="Breakdown Details" class="breakdown-btn" /></button>
          </div>
        </ng-template>
      </div>
      }
    </ng-container>

    <!-- Mobile / <=1024: table layout (events-results group_table_mobile pattern) -->
    <ng-container *ngIf="!layoutWide1024">
      <table class="group_table_mobile point-leaderboard-table-mobile">
        <colgroup>
          <col class="plb-gtm-col-rank" />
          <col class="gtm-col-name" />
          @for (_ of plbMobileStatColIndices; track $index) {
          <col class="gtm-col-stat" />
          }
        </colgroup>
        <thead>
          <tr>
            <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'rank')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'rank')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'rank')">
              {{ "rank" | translate | uppercase }}
            </button></th>
            <th scope="col" class="f_12 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'player')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'player')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'player')">
              {{ "player" | translate | uppercase }}
            </button></th>
            <ng-container *ngIf="parent_role_list.length > 0">
              <th scope="col" class="f_11 stupa-abbr-th" *ngFor="let role of parent_role_list; trackBy: trackById"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, null)" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), null)" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), null)">
                {{ mobileLeaderboardRoleHeader(role) }}
              </button></th>
            </ng-container>
            <ng-container *ngIf="parent_role_list.length === 0">
              <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'club/ma')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'club/ma')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'club/ma')">
                {{ setHeaderAbbr('club') }}
                
              </button></th>
            </ng-container>
            <ng-container *ngIf="leaderboardMode === 'RankingAndRating'; else plbMobRankingHeaders">
              <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'ranking_points')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'ranking_points')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'ranking_points')">
                {{ setHeaderAbbr('bonus_points') }}
                
              </button></th>
              <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'rating_points')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'rating_points')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'rating_points')">
                {{ setHeaderAbbr('elo_points') }}
                
              </button></th>
              <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, 'total_points')" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), 'total_points')" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), 'total_points')">
                {{ setHeaderAbbr('total_points') }}
                
              </button></th>
            </ng-container>
            <ng-template #plbMobRankingHeaders>
              <th scope="col" class="f_11 stupa-abbr-th"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, null)" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), null)" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), null)">
                {{ setHeaderAbbr('points') }}
              </button></th>
              <th scope="col" class="f_11 stupa-abbr-th" *ngFor="let event of filteredEventNamesForView; trackBy: trackById"><button type="button" (click)="onMobileLeaderboardHeaderClick($event, null)" (keydown.enter)="onMobileLeaderboardHeaderClick($any($event), null)" (keydown.space)="$event.preventDefault(); onMobileLeaderboardHeaderClick($any($event), null)">
                {{ mobileLeaderboardEventHeader(event) }}
              </button></th>
            </ng-template>
          </tr>
        </thead>
        <tbody>
          @for (ranking of rankings; track trackRanking($index, ranking)) {
          <tr class="point-leaderboard-table-mobile__row" (click)="onBreakdownClick(ranking, $event)" (keydown.enter)="onBreakdownClick(ranking, $any($event))" (keydown.space)="$event.preventDefault(); onBreakdownClick(ranking, $any($event))">
            <td class="f_11">
              <div id="st-point-leaderboard-block-69" class="d-flex align-items-center gap-1 flex-wrap">
                <ng-container *ngIf="leaderboardMode !== 'RankingAndRating'">
                  <img *ngIf="ranking.movementIndicator === '+'"
                    src="../../../assets/ranking-rating_assets/positive_indicator.svg" alt="Rank Up"
                    class="rank-indicator" />
                  <img *ngIf="ranking.movementIndicator === '-'"
                    src="../../../assets/ranking-rating_assets/negative_indicator.svg" alt="Rank Down"
                    class="rank-indicator" />
                </ng-container>
                <span class="rank-number">{{ ranking.rank }}</span>
              </div>
            </td>
            <td class="f_12">
              <div id="st-point-leaderboard-min-w-0" class="d-flex align-items-center gap-1 min-w-0">
                <img [src]="
                    ranking?.player_profile ||
                    setAvatarByGender(ranking?.gender_id || '')
                  " alt="Player Profile" class="player-profile-pic" />
                <span class="player-name st-ellipsis min-w-0" tooltipPosition="right" [pTooltip]="ranking?.player || ''"
                  tooltipStyleClass="stupa-compact-tooltip">
                  {{ ranking?.player }}
                </span>
                <img *ngIf="leaderboardMode !== 'RankingAndRating' && ranking.is_paused"
                  src="../../../assets/ranking-rating_assets/pause_player.svg" alt="Paused Player"
                  class="pause-icon flex-shrink-0" />
              </div>
            </td>
            <ng-container *ngIf="parent_role_list.length > 0">
              <td *ngFor="let role of parent_role_list; trackBy: trackById" class="f_11">
                <span class="st-ellipsis w-100 d-inline-block" tooltipPosition="left"
                  [pTooltip]="getParentValueForRole(ranking, role.parent_role_id)"
                  tooltipStyleClass="stupa-compact-tooltip">
                  {{ getParentValueForRole(ranking, role.parent_role_id) }}
                </span>
              </td>
            </ng-container>
            <ng-container *ngIf="parent_role_list.length === 0">
              <td class="f_11">
                <span class="st-ellipsis w-100 d-inline-block" tooltipPosition="left" [pTooltip]="ranking?.clubMa || ''"
                  tooltipStyleClass="stupa-compact-tooltip">
                  {{ ranking?.clubMa }}
                </span>
              </td>
            </ng-container>
            <ng-container *ngIf="leaderboardMode === 'RankingAndRating'; else plbMobRankingCells">
              <td class="f_11">{{ ranking?.bonusPoints ?? 0 }}</td>
              <td class="f_11">{{ ranking?.eloPoints ?? 0 }}</td>
              <td class="f_11">{{ ranking?.totalPoints ?? 0 }}</td>
            </ng-container>
            <ng-template #plbMobRankingCells>
              <td class="f_11">{{ ranking?.points }}</td>
              <td *ngFor="let event of filteredEventNamesForView; trackBy: trackById"
                class="f_11">
                <span class="st-ellipsis w-100 d-inline-block" tooltipPosition="left"
                  [pTooltip]="(ranking.event_points?.[event.event_id] ?? '-') + ''"
                  tooltipStyleClass="stupa-compact-tooltip">
                  {{ ranking.event_points?.[event.event_id] || "-" }}
                </span>
              </td>
            </ng-template>
          </tr>
          }
        </tbody>
      </table>
    </ng-container>

    <!-- Mobile infinite scroll loading indicator -->
    <div id="st-point-leaderboard-mobile-load-more-indicator" *ngIf="isMobileView && mobileLoadingMore" class="mobile-load-more-indicator">
      <stupa-skeleton-loader [rows]="3" />
    </div>

    <div id="st-point-leaderboard-pagination-container" *ngIf="rankings.length != 0 && !isMobileView" class="pagination-container">
      <div id="st-point-leaderboard-pagination-buttons" class="pagination-buttons">
        <button class="pagination-btn" (click)="goToFirstPage()" (keydown.enter)="goToFirstPage()" (keydown.space)="$event.preventDefault(); goToFirstPage()" [disabled]="currentPage === 1" tabindex="0">
          <img src="../../../assets/ranking-rating_assets/navigation_arrow2.svg" alt="First Page"
            class="pagination-icon double-arrow left" />
        </button>
        <button class="pagination-btn" (click)="prevPage()" (keydown.enter)="prevPage()" (keydown.space)="$event.preventDefault(); prevPage()" [disabled]="currentPage === 1" tabindex="0">
          <img src="../../../assets/ranking-rating_assets/navigation_arrow.svg" alt="Previous Page"
            class="pagination-icon single-arrow left" />
        </button>
        @for (page of pageNumbersForView; track page) {
        <button class="pagination-btn"
          [class.active]="currentPage === page" (click)="goToPage(page)" (keydown.enter)="goToPage(page)" (keydown.space)="$event.preventDefault(); goToPage(page)" tabindex="0">
          {{ page }}
        </button>
        }
        <button class="pagination-btn" (click)="nextPage()" (keydown.enter)="nextPage()" (keydown.space)="$event.preventDefault(); nextPage()" [disabled]="currentPage === totalPages" tabindex="0">
          <img src="../../../assets/ranking-rating_assets/navigation_arrow.svg" alt="Next Page"
            class="pagination-icon single-arrow right" />
        </button>
        <button class="pagination-btn" (click)="goToLastPage()" (keydown.enter)="goToLastPage()" (keydown.space)="$event.preventDefault(); goToLastPage()" [disabled]="currentPage === totalPages" tabindex="0">
          <img src="../../../assets/ranking-rating_assets/navigation_arrow2.svg" alt="Last Page"
            class="pagination-icon double-arrow right" />
        </button>
      </div>
      <div id="st-point-leaderboard-items-per-page" class="items-per-page d-none d-md-block">
        <span>{{ getStartIndex() }} - &nbsp;</span>
        <select [(ngModel)]="itemsPerPage" (ngModelChange)="onItemsPerPageChange()" class="items-per-page-dropdown"
          aria-label="Items per page">
          <option *ngFor="let option of itemsPerPageOptions; trackBy: trackById" [value]="option">
            {{ option }}
          </option>
        </select>
        <span> {{ "of" | translate }} {{ totalItems }}</span>
      </div>
    </div>
  </div>
  
  <div id="st-point-leaderboard-on-hold"
    *ngIf="isCategoryOnHold && hasLoadedStandings && !load_standings"
    class="on-hold-state d-flex flex-column align-items-center justify-content-center w-100 my-5 py-5">
    <div class="on-hold-icon-circle">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <rect x="5" y="3" width="4" height="18" rx="1" fill="currentColor"/>
        <rect x="15" y="3" width="4" height="18" rx="1" fill="currentColor"/>
      </svg>
    </div>
    <h3 class="on-hold-title fw-bold fs-18 mt-3 mb-0">{{ "ranking_on_hold_title" | translate }}</h3>
    <p class="on-hold-subtitle fs-12 fw-normal mt-2 mb-0">{{ "ranking_on_hold_subtitle" | translate }}</p>
    @if (categoryHoldReason) {
      <div class="on-hold-reason-pill fs-12 fw-medium mt-3">{{ categoryHoldReason }}</div>
    }
  </div>

  <div id="st-point-leaderboard-text-center" *ngIf="rankings.length === 0 && !load_standings && hasLoadedStandings && !isCategoryOnHold"
    class="text-center norecord d-flex flex-column align-items-center w-100 justify-content-center my-5 py-5">
    <img src="../../../assets/ranking-rating_assets/no_record_found.svg" alt="No Records" />
    <p class="no-record">
      {{ "ranking_standing_no_data_available" | translate }}
    </p>
  </div>

  <stupa-leaderboard-sidebar *ngIf="isSidebarOpen" (panelClose)="closeSidebar()" (applyFilters)="onApplyFilters($event)"
    [clubs]="clubs" [clubsRoleId]="clubsRoleId" [seasons]="seasons" [events]="events" [timeline]="timeline" [selectedSeasonId]="selectedSeasonId"
    [selectedTimelineId]="selectedTimelineId" [timelineSeasonId]="timelineSeasonId" [parents]="parents"
    [parent_role_list]="parent_role_list" [filterRankMin]="filterRankMin" [filterRankMax]="filterRankMax"
    [dateFrom]="dateFrom" [dateTo]="dateTo" [filterEventIds]="filterEventIds" [filterSeasonId]="filterSeasonId"
    [totalItems]="totalItems"></stupa-leaderboard-sidebar>
  <stupa-point-breakdown [currentParticipantName]="current_participant_name" *ngIf="isBreakdownSidebarOpen"
    (panelClose)="closeBreakdownSidebar()" (pauseStatusChanged)="onPauseStatusChanged()"
    [participantId]="selectedParticipantId" [categoryId]="selectedCategoryId"
    [selectedBreakdownPoints]="selectedBreakdownPoints"></stupa-point-breakdown>
  <stupa-table-legend-overlay #leaderboardLegendOverlay [items]="activeLegendItems"></stupa-table-legend-overlay>
  @if (showStandingsSkeleton) {
  <stupa-skeleton-loader id="st-point-leaderboard-skeleton" class="p-3" [rows]="10" />
  }
</div>